import { createInstallerData } from 'components/DEBForm/Utils/DebTestAccountSetup';

import { STORAGE_KEY } from 'global/constants';

import { getTestingAccountItemMap } from 'utils/FormUtils';
import { isLocal } from 'utils/StageUtils';
import { getTenantId } from 'utils/tenantUtil';

const energyExtension = localStorage.getItem(STORAGE_KEY.ENERGY_EXTENSION) === 'true';
const gasExtension = localStorage.getItem(STORAGE_KEY.GAS_EXTENSION) === 'true';

export const DEB_TEST_SUITES = (tenantId) => ({
  MainEnergyNonH: {
    installerData: createInstallerData(
      tenantId,
      'MainEnergyNonH',
      '',
      energyExtension,
      gasExtension
    ),
    id: 1,
  },
  MainEnergyH: {
    installerData: createInstallerData(tenantId, 'MainEnergyH', '', energyExtension, gasExtension),
    id: 2,
  },
  MainGasNonH: {
    installerData: createInstallerData(tenantId, '', 'MainGasNonH', energyExtension, gasExtension),
    id: 3,
  },
  MainGasH: {
    installerData: createInstallerData(tenantId, '', 'MainGasH', energyExtension, gasExtension),
    id: 4,
  },
  MainEnergyNonHMainGasNonH: {
    installerData: createInstallerData(
      tenantId,
      'MainEnergyNonH',
      'MainGasNonH',
      energyExtension,
      gasExtension
    ),
    id: 5,
  },
  MainEnergyHMainGasNonH: {
    installerData: createInstallerData(
      tenantId,
      'MainEnergyH',
      'MainGasNonH',
      energyExtension,
      gasExtension
    ),
    id: 6,
  },
  MainEnergyNonHMainGasH: {
    installerData: createInstallerData(
      tenantId,
      'MainEnergyNonH',
      'MainGasH',
      energyExtension,
      gasExtension
    ),
    id: 7,
  },
  MainEnergyHMainGasH: {
    installerData: createInstallerData(
      tenantId,
      'MainEnergyH',
      'MainGasH',
      energyExtension,
      gasExtension
    ),
    id: 8,
  },
  MainEnergyNonHGuestGasNonH: {
    installerData: createInstallerData(
      tenantId,
      'MainEnergyNonH',
      'GuestGasNonH',
      energyExtension,
      gasExtension
    ),
    id: 9,
  },
  MainEnergyHGuestGasNonH: {
    installerData: createInstallerData(
      tenantId,
      'MainEnergyH',
      'GuestGasNonH',
      energyExtension,
      gasExtension
    ),
    id: 10,
  },
  MainEnergyNonHGuestGasH: {
    installerData: createInstallerData(
      tenantId,
      'MainEnergyNonH',
      'GuestGasH',
      energyExtension,
      gasExtension
    ),
    id: 11,
  },
  MainEnergyHGuestGasH: {
    installerData: createInstallerData(
      tenantId,
      'MainEnergyH',
      'GuestGasH',
      energyExtension,
      gasExtension
    ),
    id: 12,
  },
  GuestEnergyNonHMainGasNonH: {
    installerData: createInstallerData(
      tenantId,
      'GuestEnergyNonH',
      'MainGasNonH',
      energyExtension,
      gasExtension
    ),
    id: 13,
  },
  GuestEnergyNonHMainGasH: {
    installerData: createInstallerData(
      tenantId,
      'GuestEnergyNonH',
      'MainGasH',
      energyExtension,
      gasExtension
    ),
    id: 14,
  },
  GuestEnergyHMainGasNonH: {
    installerData: createInstallerData(
      tenantId,
      'GuestEnergyH',
      'MainGasNonH',
      energyExtension,
      gasExtension
    ),
    id: 15,
  },
  GuestEnergyHMainGasH: {
    installerData: createInstallerData(
      tenantId,
      'GuestEnergyH',
      'MainGasH',
      energyExtension,
      gasExtension
    ),
    id: 16,
  },
  GuestEnergyNonH: {
    installerData: createInstallerData(
      tenantId,
      'GuestEnergyNonH',
      '',
      energyExtension,
      gasExtension
    ),
    id: 17,
  },

  GuestGasNonH: {
    installerData: createInstallerData(tenantId, '', 'GuestGasNonH', energyExtension, gasExtension),
    id: 18,
  },
  GuestEnergyH: {
    installerData: createInstallerData(tenantId, 'GuestEnergyH', '', energyExtension, gasExtension),
    id: 19,
  },
  GuestGasH: {
    installerData: createInstallerData(tenantId, '', 'GuestGasH', energyExtension, gasExtension),
    id: 20,
  },
  GuestEnergyNonHGuestGasNonH: {
    installerData: createInstallerData(
      tenantId,
      'GuestEnergyNonH',
      'GuestGasNonH',
      energyExtension,
      gasExtension
    ),
    id: 21,
  },
  GuestEnergyHGuestGasNonH: {
    installerData: createInstallerData(
      tenantId,
      'GuestEnergyH',
      'GuestGasNonH',
      energyExtension,
      gasExtension
    ),
    id: 22,
  },
  GuestEnergyNonHGuestGasH: {
    installerData: createInstallerData(
      tenantId,
      'GuestEnergyNonH',
      'GuestGasH',
      energyExtension,
      gasExtension
    ),
    id: 23,
  },
  GuestEnergyHGuestGasH: {
    installerData: createInstallerData(
      tenantId,
      'GuestEnergyH',
      'GuestGasH',
      energyExtension,
      gasExtension
    ),
    id: 24,
  },
});
const shouldFillDebTestData = localStorage.getItem(STORAGE_KEY.FILL_DEB_FORM) === 'true';
const selectedTestSuiteValueLocalStorage = localStorage.getItem(
  STORAGE_KEY.DEB_SELECTED_TEST_SUITE
);
const selectedTestSuiteValue =
  selectedTestSuiteValueLocalStorage || getTestingAccountItemMap()[0].value;

if (!selectedTestSuiteValueLocalStorage) {
  localStorage.setItem(STORAGE_KEY.DEB_SELECTED_TEST_SUITE, selectedTestSuiteValue);
}

const DEB_CURRENT_TEST_SUITE = DEB_TEST_SUITES(getTenantId())[selectedTestSuiteValue];
if (isLocal()) {
  console.warn(
    'Current DEB Testsuite:',
    getTenantId(),
    selectedTestSuiteValue,
    DEB_CURRENT_TEST_SUITE,
    energyExtension,
    gasExtension
  );
}
export {
  DEB_CURRENT_TEST_SUITE,
  shouldFillDebTestData,
  selectedTestSuiteValue,
  energyExtension,
  gasExtension,
};
